import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import './pages.css'
import axios from 'axios'
import { M_InputTextField, M_Button, BufferService, DefaultURl, M_TransferList, M_Fieldset, M_Header, LoadingContext } from 'src/M_Components'

export const UserConfigCrud = ({ handleTabClose, toastMessages }) => {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()
  const passOperation = sessionStorage.getItem('operation') !== null ? sessionStorage.getItem('operation') : 'Error'
  const sessionLine = sessionStorage.getItem('UserLine') !== null && sessionStorage.getItem('UserLine') !== undefined ? JSON.parse(sessionStorage.getItem('UserLine')) : 'Error'
  const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
  const [operation, setOperation] = useState(passOperation)
  const [passLine, setPassLine] = useState('')
  const [userInfo, setUserInfo] = useState({})
  const [roles, setRoles] = useState([])
  const [userRoles, setUserRoles] = useState([])
  const [companies, setCompanies] = useState([])
  const [userCompanies, setUserCompanies] = useState([])
  const [isFirst, setIsFirst] = useState(true)

  const companiesService = new BufferService('Company')
  const rolesService = new BufferService('role')
  const profileService = new BufferService('profile/get')

  const sessionKeys = ['passLine', 'operation', 'userInfo', 'roles', 'userRoles', 'companies', 'userCompanies', 'isFirst']

  useEffect(() => {
    if (isFirst) {
      sessionStorage.removeItem('UserLine')
      sessionStorage.removeItem('role')
      setPassLine(sessionLine)
      setIsFirst(false)
    }
    getSessionStorageData(id)
    sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
  }, [])

  const sessionStorageMachine = (id, key, value) => {
    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
    } else {
      // eslint-disable-next-line
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
    }
  }

  const getSessionStorageData = (sessionID) => {
    const tempPL = JSON.parse(sessionStorage.getItem(`${sessionID}passLine`))
    const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
    const tempUI = JSON.parse(sessionStorage.getItem(`${sessionID}userInfo`))
    const tempR = JSON.parse(sessionStorage.getItem(`${sessionID}roles`))
    const tempUR = JSON.parse(sessionStorage.getItem(`${sessionID}userRoles`))
    const tempC = JSON.parse(sessionStorage.getItem(`${sessionID}companies`))
    const tempUC = JSON.parse(sessionStorage.getItem(`${sessionID}userCompanies`))
    const tempIF = JSON.parse(sessionStorage.getItem(`${sessionID}isFirst`))
    if (tempPL || tempO || tempUI || tempR || tempUR || tempC || tempUC || tempIF) {
      setPassLine(tempPL)
      setOperation(tempO)
      setUserInfo(tempUI)
      setRoles(tempR)
      setUserRoles(tempUR)
      setCompanies(tempC)
      setUserCompanies(tempUC)
      setIsFirst(tempIF)
      return
    }
    getRefresh(sessionLine)
  }

  const getRefresh = (line) => {
    ctx.setIsLoad(true)
    const lineUser = line ? line : passLine
    let tempUserInfo = {}
    let tempRoles = []
    let tempUserRoles = []
    let tempCompanies = []
    let tempUserCompanies = []

    ctx.setIsLoad(false)
    if (operation === 'Create') {
      setUserInfo({
        'Username': '',
        'Email': '',
        'Password': '',
        'Id': '',
      })
      setUserRoles([])
      setUserCompanies([])
    } else {
      if (lineUser === 'Error') {
        handleTabClose(JSON.parse(id))
        toastMessages('error', '', t("SelectedLine"))
        return
      }
      // return
      axios.get(`${DefaultURl}identity/registerextras/${lineUser.Id}`).then(res => {
        toastMessages('success', 'Data received', '')

        tempUserInfo.Username = res.data.Username
        tempUserInfo.Email = res.data.Email
        tempUserInfo.Id = lineUser.Id

        res.data.ListCompanies.forEach(userComp => {
          tempUserCompanies.push(userComp)
        })

        res.data.ListRoleId.forEach(userRol => {
          tempUserRoles.push(userRol)
        })

        setUserInfo(tempUserInfo)

        setUserRoles(tempUserRoles)

        setUserCompanies(tempUserCompanies)

      }).catch(error => {
        handleTabClose(JSON.parse(id))
        toastMessages('error', error.message, '')
        return
      })
    }
  }

  useEffect(() => {
    const newId = sessionStorage.getItem('selectedTab')
    if (newId !== id) {
      setId(newId)
      getSessionStorageData(newId)
    }
  })

  useEffect(() => {
    sessionKeys.forEach(key => {
      sessionStorageMachine(id, key, key)
    })
  }, [id, operation, passLine, userInfo, roles, userRoles, companies, userCompanies, isFirst])

  const onSave = () => {
    ctx.setIsLoad(true)
    const saveRoles = userRoles.map(obj => {
      return obj.Id
    })
    const saveCompanies = userCompanies.map(obj => {
      return obj.Code
    })
    profileService.get().then(profData => {
      if (profData.name === 'AxiosError') {
        ctx.setIsLoad(false)
        toastMessages('error', profData.message, '')
        return
      }

      const User = {
        'username': userInfo.Username,
        'email': userInfo.Email,
        'password': userInfo.Password || '',
        'roleId': saveRoles,
        'Notes': 'notes',
        'notes': 'notes',
        'companies': saveCompanies,
        "profileId": profData[0].Id,
      }
      if (User.companies.length === 0) {
        toastMessages('error', t('NoCompany'), '')
        return
      }
      if (User.roleId.length === 0) {
        toastMessages('error', t('NoRole'), '')
        return
      }

      if (operation === 'Create' || operation === 'Copy') {
        axios.post(`${DefaultURl}identity/registerextras/`, User).then(res => {
          ctx.setIsLoad(false)
          handleTabClose(JSON.parse(id))
          toastMessages('success', t('UserCreated'), '')
          return
        }).catch(error => {
          console.log(error)
          toastMessages('error', error.response.data.Errors ? error.response.data.Errors : error.message, '')
        })

      }
      if (operation === 'Edit') {
        axios.put(`${DefaultURl}identity/registerextras/${userInfo.Id}`, User).then(res => {
          ctx.setIsLoad(false)
          handleTabClose(JSON.parse(id))
          toastMessages('success', t('UserCreated'), '')
          return
        }).catch(error => {
          console.log(error)
          toastMessages('error', error.response.data.Errors ? error.response.data.Errors : error.message, '')
        })
      }

    })
  }

  return (
    <>
      <M_Header
        element={
          <>
            <M_Button
              tooltip={t("RefreshTable")}
              icon={<i className="pi pi-refresh iconTable"></i>}
              label={t("RefreshTable")}
              onClick={() => getRefresh()}
            />

            {operation !== 'View' ?
              <M_Button
                tooltip={t("Save")}
                icon={<i className="pi pi-save iconTable"></i>}
                label={t("Save")}
                onClick={() => onSave()}
              />
              : ''}
          </>
        }
      />
      <div className='containerUserConfig'>
        <M_Fieldset
          labelInside
          label={operation === 'Create' ? 'New User' : operation === 'Edit' ? 'Edit User' : "View User"}
          elements={
            <div style={{}}>
              <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '50px', padding: '0px 50px' }}>
                <div >
                  <M_InputTextField
                    label={'Username'}
                    value={userInfo.Username || ''}
                    disabled={operation === 'View'}
                    onChange={(e) => setUserInfo({ ...userInfo, Username: e.target.value })}
                  />
                </div>
                <div>
                  <M_InputTextField
                    label={'Email'}
                    value={userInfo.Email || ''}
                    disabled={operation === 'View'}
                    onChange={(e) => setUserInfo({ ...userInfo, Email: e.target.value })}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', width: '100%', padding: '50px', justifyContent: 'space-around' }}>
                {/* <div style={{ borderLeft: '2px solid var(--color-blue)' }}></div> */}
                <M_TransferList
                  disabled={operation === 'View' ? true : false}
                  header={t("User Roles")}
                  entity={'role'}
                  field={'Name'}
                  valueIdField={'Id'}
                  value={userRoles}
                  setValue={setUserRoles}
                />
                {/* <div style={{ borderLeft: '2px solid var(--color-blue)' }}></div> */}
                {/* <div style={{}}> */}
                <M_TransferList
                  disabled={operation === 'View' ? true : false}
                  header={t("User Companies")}
                  entity={'company'}
                  field={'Code'}
                  valueIdField={'Id'}
                  value={userCompanies}
                  setValue={setUserCompanies}
                />
                {/* </div> */}
              </div>
            </div>
          }
        />
      </div>
    </>
  )
}
